module.exports = __webpack_public_path__ + "static/img/g-menu-icon.c7ed1ad1.png";